import { render, staticRenderFns } from "./EditQuestionnaireUser.vue?vue&type=template&id=39b5feb0"
import script from "./EditQuestionnaireUser.vue?vue&type=script&lang=js"
export * from "./EditQuestionnaireUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports